import { OpaqueToken } from '@angular/core';

export const AUTH_CONFIG = new OpaqueToken('AuthConfig');



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build/webapp/src/app/@shared/auth/auth.config.ts